import { useMemo } from 'react'
import { useLocation } from 'wouter'
import { CameraPlusIcons } from '@/components/icons/CameraPlusIcon'
import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { useDocumentPageContextQuery } from '@/pages/DocumentPage/queries'
import { useCADPageStore, useDocumentState } from '@/state'

type ScreenshotMenuProps = {
  isDisabled: boolean
}

export const ScreenshotMenu = ({ isDisabled }: ScreenshotMenuProps) => {
  const [, setLocation] = useLocation()
  const documentPage = useDocumentPageContextQuery()
  const currentPageInView = useDocumentState((state) => state.currentPageInView)
  const setCadState = useCADPageStore((state) => state.setState)

  const projectId = documentPage.data?.project.id
  const documentId = documentPage.data?.documentId

  const cadPageLink = useMemo(
    () =>
      `~/p/${projectId}/document/${documentId}/cad?page_id=${currentPageInView}`,
    [projectId, documentId, currentPageInView],
  )

  const handleNavigateToCAD = () => {
    // Ensure the URL has the current page in view (in case scroll update is debounced)
    const currentUrl = new URL(window.location.href)
    currentUrl.searchParams.set('page_id', currentPageInView)
    const captureLocationPath = currentUrl.pathname + currentUrl.search

    setCadState({
      isCapturingScreenshotFromDocumentPage: true,
      captureLocation: `~${captureLocationPath}`,
    })
    setLocation(cadPageLink)
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            className="rounded-md hover:bg-gray-100 m-0 h-full flex py-2 px-3 items-center justify-center disabled:opacity-20"
            onClick={handleNavigateToCAD}
            disabled={isDisabled}
          >
            <CameraPlusIcons className="h-[24px] w-[24px] stroke-2" />
          </Button>
        </TooltipTrigger>
        <TooltipContent className="bg-black text-white">
          <p>Take new image from CAD</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
